// extracted by mini-css-extract-plugin
export var bcCartTitle = "cartpage-module--bcCartTitle--Ohk4w";
export var continueShopping = "cartpage-module--continueShopping--iivf3";
export var bcCartEmpty = "cartpage-module--bcCartEmpty--ZRuX6";
export var textBanner = "cartpage-module--textBanner--4PuvM";
export var bcCartContainer = "cartpage-module--bcCartContainer--ozMn8";